<template>
    <div class="page-fundraising-toolkit">
        <div class="jumbo-wrapper fundraising-toolkit">
            <div class="jumbo-main">
                <div class="jumbo-content">
                    <p class="t15">FUNDRAISING TOOLKIT</p>
                    <h2 class="t42">
                        EVERYTHING YOU NEED
                        <br/>
                        AT YOUR FINGERTIPS
                    </h2>
                    <p class="t20">We make managing your fundraiser a breeze.</p>
                </div>
            </div>
        </div>
        <div class="box-content">
            <div class="box-content-inner">
                <div class="row engraved-icons">
                    <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                        <div class="icon-box">
                            <div class="roadmap-icon">
                                <img class="" src="images/Fundraising-Toolkit/roadmapicon.png" alt="">
                            </div>
                        </div>
                        <h2>ROADMAP TO SUCCESS</h2>
                        <p>Our step-by-step guide</p>
                    </div>
                    <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                        <div class="icon-box">
                            <div class="website-icon">
                                <img class="" src="images/Fundraising-Toolkit/websiteicon.png" alt="">
                            </div>
                        </div>
                        <h2>BRICK FUNDRAISER WEBSITE</h2>
                        <p>Convenient. Online. Free.</p>
                    </div>
                    <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                        <div class="icon-box">
                            <div class="order-icon">
                                <img class="" src="images/Fundraising-Toolkit/ordericon.png" alt="">
                            </div>
                        </div>
                        <h2>ORDER MANAGEMENT TOOL</h2>
                        <p>Automatically adds donor orders</p>
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <h6 class="body-area-headline">
                            FUNDRAISING TOOLKIT
                        </h6>
                        <p>
                            Our Fundraising Toolkit includes a comprehensive Roadmap to Success, a Brick Fundraiser Website where you can take orders, as well as an integrated Order Management Tool. We package everything you need to easily navigate your fundraiser from start to finish.
                        </p>
                    </div>
                    <div class="body-area-right">
                        <img width="443" height="362" class="img-responsive" src="images/Fundraising-Toolkit/fundraisingtoolkit01.png" alt="">
                    </div>
                </div>

                <hr class="frl-hr-box"/>

                <h2 class="text-center">Roadmap to Success</h2>
                <div class="body-area">
                    <div class="body-area-left">
                        <img width="443" height="362" class="img-responsive" src="images/Fundraising-Toolkit/fundraisingtoolkit02.png" alt="">
                    </div>
                    <div class="body-area-right">
                        <h6 class="body-area-headline">
                            SUCCESS IN 6 STEPS!
                        </h6>
                        <p>
                            Our Roadmap to Success breaks down the entire process of an Engraved Brick Fundraiser into 6 steps, from conception through installation. It will guide you through your options, what you need, and when. Our goal is to make the process easy to manage and as streamlined as possible.
                        </p>
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <h6 class="body-area-headline">
                            FREE RESOURCES, TIPS,<br/>
                            AND TRICKS
                        </h6>
                        <p>
                            Compiled from our 32+ years in the industry, our Roadmap to Success includes resources to provide a complete fundraising solution, as well as tips and tricks to take your fundraiser to the next level.
                        </p>
                        <ul class="body-area-list">
                            <li><span>Free Marketing Brick/Tile</span></li>
                            <li><span>Brick/Tile Marketing Images</span></li>
                            <li><span>Example Library</span></li>
                            <li><span>Templates</span></li>
                            <li><span>Checklists</span></li>
                            <li><span>Workbook</span></li>
                            <li><span>... and More!</span></li>
                        </ul>
                        </div>
                    <div class="body-area-right">
                        <img width="450" height="356" class="img-responsive" src="images/Fundraising-Toolkit/fundraisingtoolkit03.png" alt="">
                    </div>
                </div>

                <hr class="frl-hr-box"/>

                <h2 class="text-center">Brick Fundraiser Website</h2>
                <div class="body-area">
                    <div class="body-area-left">
                        <img width="450" height="320" class="img-responsive" src="images/Fundraising-Toolkit/fundraisingtoolkit04.png" alt="">
                    </div>
                    <div class="body-area-right">
                        <h6 class="body-area-headline">
                            OFFER YOUR DONORS
                            THE CONVENIENCE OF
                            ONLINE ORDERING.
                        </h6>
                        <p>
                            We provide you an effective and easy-to-navigate resource where you can take orders and payments in real time to drive maximum success for your fundraiser.
                        </p>
                        <p>
                            <router-link to="/open-example-project-website" tag="button" class="learn-more-button">
                                <span>EXAMPLE FUNDRAISER WEBSITE</span>
                            </router-link>
                        </p>
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <h6 class="body-area-headline">
                            WITH ITS EASE OF USE
                            AND CLEAN DESIGN, IT'S
                            USER-FRIENDLY FOR BOTH
                            YOU AND YOUR DONORS.
                        </h6>
                        <ul class="body-area-list">
                            <li><span>Step-By-Step Navigation</span></li>
                            <li><span>High-Quality Product Images</span></li>
                            <li><span>Custom Inscription Fields with Character Limits</span></li>
                            <li><span>Immediate Payment & Email Order Confirmation</span></li>
                            <li><span>Integrated Order Management Tool</span></li>
                        </ul>
                    </div>
                    <div class="body-area-right">
                        <img width="443" height="362" class="img-responsive" src="images/Fundraising-Toolkit/fundraisingtoolkit05.png" alt="">
                    </div>
                </div>

                <hr class="frl-hr-box"/>

                <h2 class="text-center">Order Management Tool</h2>
                <div class="body-area">
                    <div class="body-area-left">
                        <img width="443" height="362" class="img-responsive" src="images/Fundraising-Toolkit/fundraisingtoolkit06.png" alt="">
                    </div>
                    <div class="body-area-right">
                        <h6 class="body-area-headline">
                            ORDERS ARE AUTOMATICALLY
                            TRANSFERRED FROM YOUR BRICK
                            FUNDRAISER WEBSITE.
                        </h6>
                        <p>
                            As soon as a donor places their order online, those order details are automatically entered on an easy-to-use Google Sheet, accessible online from any device. Easily review orders for accuracy and at the end of your selling phase, provide the link through our Order Submission Form and you're all set!
                        </p>
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <h6 class="body-area-headline">
                            YOUR ORDER MANAGEMENT<br/>
                            TOOL AND WEBSITE ARE<br/>
                            CREATED TOGETHER, WITH<br/>
                            NO ADDITIONAL SETUP.
                        </h6>
                        <ul class="body-area-list">
                            <li><span>Ready to Use Immediately</span></li>
                            <li><span>Orders Appear Instantly</span></li>
                            <li><span>Administrative Notes Section</span></li>
                            <li><span>Automatically Collects Donor Logo Files</span></li>
                        </ul>
                    </div>
                    <div class="body-area-right">
                        <img width="443" height="362" class="img-responsive" src="images/Fundraising-Toolkit/fundraisingtoolkit07.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'fundraising-toolkit',
        components: {
        },
        metaInfo: {
            title: 'Fundraising Toolkit',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: ''
                }
            ]
        }
    }
</script>



// WEBPACK FOOTER //
// FundraisingToolkit.vue?f4eee03c